import React, { useState, createContext } from "react";

type ValueGraphContext = {
  startDate: string;
  endDate: string;
  setDates: (data: Record<string, any>) => void;
};

export const GrapghContext = createContext<ValueGraphContext | undefined>(
  undefined
);

const GraphProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const setDates = (data: Record<string, any>) => {
    setStartDate(data.startDate);
    setEndDate(data.endDate);
  };

  return (
    <GrapghContext.Provider
      value={{
        startDate,
        endDate,
        setDates,
      }}
    >
      {children}
    </GrapghContext.Provider>
  );
};

export default GraphProvider;
